<script>
import baseMixin from '@/mixins/baseMixin'
import UserAvatar from '../user/user-avatar.vue'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'CandidateInfoCard',
  components: { UserAvatar, InfoLabel },
  mixins: [baseMixin],
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    phoneNumbers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasPhoneNumbers() {
      return this.phoneNumbers.length > 0
    },
  },
}
</script>

<template>
  <v-card class="elevation-0 rounded-lg" outlined>
    <v-card-title class="d-flex align-center">
      <UserAvatar :name="name" />
      <p class="mb-0 ml-4 text-subtitle-2 font-weight-medium">
        <BaseLink
          :href="returnCandidateUrl(id)"
          :class="isDarkMode ? 'white--text' : 'black--text'"
          :title="$t('general.link.viewCandidateTooltip')"
          allow-insecure
          >{{ name }}</BaseLink
        >
      </p>
    </v-card-title>
    <v-card-text>
      <InfoLabel
        v-if="email"
        class="mb-4 mt-4"
        :label="$t('forms.labels.email')"
      >
        <BaseLink :href="`mailto:${email}`" target="_self" hide-external-icon>{{
          email
        }}</BaseLink>
      </InfoLabel>

      <InfoLabel
        v-if="hasPhoneNumbers"
        :label="$t('forms.labels.contactNumbers')"
      >
        <BaseLink
          v-for="(phoneNumber, index) of phoneNumbers"
          :key="phoneNumber + index"
          :href="`tel:${phoneNumber}`"
          target="_self"
          hide-external-icon
          >{{ phoneNumber }}</BaseLink
        >
      </InfoLabel>
    </v-card-text>

    <slot name="actions"> </slot>
  </v-card>
</template>
